module.exports = __webpack_public_path__ + "img/Warenty.8a3f0af4.svg";